<template>
    <router-view></router-view>
</template>
<script>
    export default {
        props: {
        },
        computed: {
        }
    }
</script>
